var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const apiVersion = '3.13.0';
import { clone, extend, get, isArray, isDate, isEmpty, isEqual, isNumber, isObject, isPlainObject, isString, uniqueId } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { element } from 'angular';
import { Model } from '@stratusjs/angularjs/services/model';
import { Collection } from '@stratusjs/angularjs/services/collection';
import { getHashBangParam, isJSON, setHashBangParam } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
import '@stratusjs/idx/listTrac';
const angularJsService = ($http, $mdToast, $q, $rootScope, $window, ListTrac, orderByFilter) => {
    const sharedValues = {
        contactUrl: null,
        contactCommentVariable: null,
        contact: null,
        integrations: {
            analytics: {},
            maps: {}
        }
    };
    const defaultWhereOptions = {
        City: [],
        eCity: [],
        UnparsedAddress: [],
        StreetAddress: [],
        eStreetAddress: [],
        Location: '',
        eLocation: '',
        Status: [],
        ListingId: [],
        ListingType: [],
        CountyOrParish: [],
        eCountyOrParish: [],
        MLSAreaMajor: [],
        eMLSAreaMajor: [],
        MLSAreaMinor: [],
        eMLSAreaMinor: [],
        SubdivisionName: [],
        eSubdivisionName: [],
        Neighborhood: [],
        eNeighborhood: [],
        PostalCode: [],
        CityRegion: [],
        eCityRegion: [],
        AgentLicense: [],
        OfficeNumber: [],
        OfficeName: []
    };
    let idxServicesEnabled = [];
    let tokenRefreshURL = '/ajax/request?class=property.token_auth&method=getToken';
    let sessionInitialized = false;
    let refreshLoginTimer;
    let defaultPageTitle;
    const instance = {
        disclaimer: {},
        map: {},
        member: {
            details: {},
            list: {},
            search: {}
        },
        office: {
            details: {},
            list: {},
            search: {}
        },
        property: {
            details: {},
            list: {},
            search: {}
        }
    };
    const instanceLink = {
        Disclaimer: {},
        List: {},
        Map: {},
        Search: {}
    };
    const instanceOnEmitters = {};
    const session = {
        services: [],
        lastCreated: new Date(),
        lastTtl: 0,
        contacts: []
    };
    const urlOptions = {
        Listing: {},
        Search: {}
    };
    const lastQueries = {
        whereFilter: {},
        pages: [],
        perPage: 0,
        time: null
    };
    function emit(emitterName, $scope, var1, var2, var3) {
        emitManual(emitterName, $scope.elementId, $scope, var1, var2, var3);
    }
    function emitManual(emitterName, uid, $scope, var1, var2, var3) {
        var _a, _b;
        var _c;
        if (Object.prototype.hasOwnProperty.call(instanceOnEmitters, uid) &&
            Object.prototype.hasOwnProperty.call(instanceOnEmitters[uid], emitterName)) {
            Object.values(instanceOnEmitters[uid][emitterName]).forEach((emitter) => {
                try {
                    emitter($scope, var1, var2, var3);
                }
                catch (e) {
                    console.error(e, 'issue sending back emitter on', uid, emitterName, emitter);
                }
            });
        }
        if (emitterName === 'init') {
            (_a = instanceOnEmitters[uid]) !== null && _a !== void 0 ? _a : (instanceOnEmitters[uid] = {});
            (_b = (_c = instanceOnEmitters[uid])[emitterName]) !== null && _b !== void 0 ? _b : (_c[emitterName] = {});
        }
    }
    function removeOnManual(emitterName, emitterId, onId) {
        if (Object.prototype.hasOwnProperty.call(instanceOnEmitters, emitterId) &&
            Object.prototype.hasOwnProperty.call(instanceOnEmitters[emitterId], emitterName) &&
            Object.prototype.hasOwnProperty.call(instanceOnEmitters[emitterId][emitterName], onId)) {
            delete instanceOnEmitters[emitterId][emitterName][onId];
        }
    }
    function on(uid, emitterName, callback) {
        if (emitterName === 'init' &&
            Object.prototype.hasOwnProperty.call(instanceOnEmitters, uid) &&
            Object.prototype.hasOwnProperty.call(instanceOnEmitters[uid], emitterName) &&
            Object.prototype.hasOwnProperty.call(Stratus.Instances, uid)) {
            callback(Stratus.Instances[uid]);
            return;
        }
        if (uid === 'Idx' &&
            emitterName === 'sessionInit' &&
            sessionInitialized) {
            callback(null);
            return;
        }
        if (!Object.prototype.hasOwnProperty.call(instanceOnEmitters, uid)) {
            instanceOnEmitters[uid] = {};
        }
        if (!Object.prototype.hasOwnProperty.call(instanceOnEmitters[uid], emitterName)) {
            instanceOnEmitters[uid][emitterName] = {};
        }
        const onId = uniqueId();
        instanceOnEmitters[uid][emitterName][onId] = callback;
        return () => { removeOnManual(uid, emitterName, onId); };
    }
    function registerDetailsInstance(uid, moduleName, $scope) {
        instance[moduleName].details[uid] = $scope;
    }
    function registerListInstance(uid, moduleName, $scope) {
        if (!Object.prototype.hasOwnProperty.call(instance, moduleName)) {
            instance[moduleName].list = {};
        }
        instance[moduleName].list[uid] = $scope;
        if (!Object.prototype.hasOwnProperty.call(instanceLink.List, uid)) {
            instanceLink.List[uid] = [];
        }
    }
    function registerSearchInstance(uid, moduleName, $scope, listUid) {
        instance[moduleName].search[uid] = $scope;
        if (!Object.prototype.hasOwnProperty.call(instanceLink.Search, uid)) {
            instanceLink.Search[uid] = [];
        }
        if (listUid) {
            instanceLink.Search[uid].push(listUid);
            if (!Object.prototype.hasOwnProperty.call(instanceLink.List, listUid)) {
                instanceLink.List[listUid] = [];
            }
            instanceLink.List[listUid].push(uid);
        }
    }
    function unregisterDetailsInstance(uid, moduleName) {
        if (Object.prototype.hasOwnProperty.call(instance[moduleName].details, uid)) {
            const detailUid = instance[moduleName].details[uid].elementId;
            delete instance[moduleName].details[uid];
            Stratus.Instances.Clean(detailUid);
        }
    }
    function registerMapInstance(uid, $scope) {
        if (!Object.prototype.hasOwnProperty.call(instance, 'map')) {
            instance.map = {};
        }
        instance.map[uid] = $scope;
        if (!Object.prototype.hasOwnProperty.call(instanceLink.Map, uid)) {
            instanceLink.Map[uid] = [];
        }
    }
    function registerDisclaimerInstance(uid, $scope) {
        if (!Object.prototype.hasOwnProperty.call(instance, 'disclaimer')) {
            instance.disclaimer = {};
        }
        instance.disclaimer[uid] = $scope;
        if (!Object.prototype.hasOwnProperty.call(instanceLink.Disclaimer, uid)) {
            instanceLink.Disclaimer[uid] = [];
        }
    }
    function getDefaultWhereOptions() {
        return clone(defaultWhereOptions);
    }
    function getSearchInstanceLinks(searchUid, moduleName = 'property') {
        const linkedLists = [];
        if (Object.prototype.hasOwnProperty.call(instanceLink.Search, searchUid)) {
            instanceLink.Search[searchUid].forEach((listUid) => {
                if (Object.prototype.hasOwnProperty.call(instance[moduleName].list, listUid)) {
                    linkedLists.push(instance[moduleName].list[listUid]);
                }
            });
        }
        return linkedLists;
    }
    function getListInstance(listUid, moduleName = 'property') {
        return Object.prototype.hasOwnProperty.call(instanceLink.List, listUid) ? instance[moduleName].list[listUid] : null;
    }
    function getListInstanceLinks(listUid, moduleName = 'property') {
        const linkedSearches = [];
        if (Object.prototype.hasOwnProperty.call(instanceLink.List, listUid)) {
            instanceLink.List[listUid].forEach((searchUid) => {
                if (Object.prototype.hasOwnProperty.call(instance[moduleName].list, searchUid)) {
                    linkedSearches.push(instance[moduleName].list[searchUid]);
                }
            });
        }
        return linkedSearches;
    }
    function getDisclaimerInstance(disclaimerUid) {
        return disclaimerUid ? (Object.prototype.hasOwnProperty.call(instance.disclaimer, disclaimerUid) ?
            { [instance.disclaimer[disclaimerUid].elementId]: instance.disclaimer[disclaimerUid] } : null) : instance.disclaimer;
    }
    function setPageTitle(title) {
        if (!defaultPageTitle) {
            defaultPageTitle = JSON.parse(JSON.stringify($window.document.title));
        }
        if (!title) {
            $window.document.title = defaultPageTitle;
        }
        else {
            $window.document.title = title;
        }
    }
    function getIdxServices() {
        return idxServicesEnabled;
    }
    function setIdxServices(services) {
        idxServicesEnabled = services;
    }
    function setTokenURL(url) {
        tokenRefreshURL = url;
    }
    function tokenKeepAuth(keepAlive = false) {
        return $q((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                if (Object.keys(session.services).length < 1 ||
                    session.expires < new Date(Date.now() + (5 * 1000))) {
                    yield tokenRefresh(keepAlive, true);
                    resolve();
                }
                else {
                    resolve();
                }
            }
            catch (err) {
                console.error('tokenKeepAuth Error:', err);
                reject(err);
            }
        }));
    }
    function tokenRefresh(keepAlive = false, cacheReset = false) {
        return $q((resolve, reject) => {
            let additionalQueries = `&apiVersion=${apiVersion}`;
            if (idxServicesEnabled.length !== 0) {
                idxServicesEnabled.forEach((service) => {
                    additionalQueries += `&service[]=${service}`;
                });
            }
            if (cacheReset) {
                additionalQueries += '&cacheReset=true';
            }
            $http({
                method: 'GET',
                url: tokenRefreshURL + additionalQueries
            }).then((response) => {
                if (typeof response === 'object' &&
                    Object.prototype.hasOwnProperty.call(response, 'data') &&
                    Object.prototype.hasOwnProperty.call(response.data, 'services') &&
                    Object.prototype.hasOwnProperty.call(response.data.services, 'length')) {
                    tokenHandleGoodResponse(response, keepAlive);
                    resolve();
                }
                else {
                    reject(tokenHandleBadResponse(response));
                }
            }, (response) => {
                reject(tokenHandleBadResponse(response));
            });
        });
    }
    function tokenHandleGoodResponse(response, keepAlive = false) {
        session.services = {};
        response.data.services.forEach((service) => {
            if (Object.prototype.hasOwnProperty.call(service, 'id')) {
                if (!Object.prototype.hasOwnProperty.call(service, 'fetchTime')) {
                    service.fetchTime = {
                        Property: null,
                        Media: null,
                        Member: null,
                        Office: null,
                        OpenHouse: null
                    };
                }
                if (!Object.prototype.hasOwnProperty.call(service, 'analyticsEnabled') ||
                    service.analyticsEnabled === null) {
                    service.analyticsEnabled = [];
                }
                if (!Object.prototype.hasOwnProperty.call(service, 'logo') ||
                    service.logo === null) {
                    service.logo = {
                        default: null
                    };
                }
                if (!Object.prototype.hasOwnProperty.call(service, 'mandatoryLogo') ||
                    service.mandatoryLogo === null) {
                    service.mandatoryLogo = [];
                }
                session.services[service.id] = service;
                session.lastCreated = new Date(service.created);
                session.lastTtl = service.ttl;
                session.expires = new Date(session.lastCreated.getTime() + (session.lastTtl - 15) * 1000);
            }
        });
        if (Object.prototype.hasOwnProperty.call(response.data, 'contactUrl')
            && response.data.contactUrl !== '') {
            sharedValues.contactUrl = response.data.contactUrl;
        }
        if (Object.prototype.hasOwnProperty.call(response.data, 'contactCommentVariable')
            && response.data.contactCommentVariable !== '') {
            sharedValues.contactCommentVariable = response.data.contactCommentVariable;
        }
        if (Object.prototype.hasOwnProperty.call(response.data, 'contact')) {
            sharedValues.contact = {
                name: '',
                emails: {},
                locations: {},
                phones: {},
                socialUrls: {},
                urls: {},
            };
            if (Object.prototype.hasOwnProperty.call(response.data, 'site')
                && isString(response.data.site)
                && response.data.site !== '') {
                sharedValues.contact.name = response.data.site;
            }
            if (Object.prototype.hasOwnProperty.call(response.data, 'contactName')
                && isString(response.data.contactName)
                && response.data.site !== '') {
                sharedValues.contact.name = response.data.contactName;
            }
            if (Object.prototype.hasOwnProperty.call(response.data, 'contact')
                && isPlainObject(response.data.contact)) {
                if (Object.prototype.hasOwnProperty.call(response.data.contact, 'emails')
                    && isPlainObject(response.data.contact.emails)) {
                    sharedValues.contact.emails = response.data.contact.emails;
                }
                if (Object.prototype.hasOwnProperty.call(response.data.contact, 'locations')
                    && isPlainObject(response.data.contact.locations)) {
                    sharedValues.contact.locations = response.data.contact.locations;
                }
                if (Object.prototype.hasOwnProperty.call(response.data.contact, 'phones')
                    && isPlainObject(response.data.contact.phones)) {
                    sharedValues.contact.phones = response.data.contact.phones;
                }
                if (Object.prototype.hasOwnProperty.call(response.data.contact, 'socialUrls')
                    && isPlainObject(response.data.contact.socialUrls)) {
                    sharedValues.contact.socialUrls = response.data.contact.socialUrls;
                }
                if (Object.prototype.hasOwnProperty.call(response.data.contact, 'urls')
                    && isPlainObject(response.data.contact.urls)) {
                    sharedValues.contact.urls = response.data.contact.urls;
                }
            }
        }
        if (Object.prototype.hasOwnProperty.call(response.data, 'integrations')) {
            if (Object.prototype.hasOwnProperty.call(response.data.integrations, 'analytics')) {
                if (Object.prototype.hasOwnProperty.call(response.data.integrations.analytics, 'googleAnalytics')) {
                    if (Object.prototype.hasOwnProperty.call(response.data.integrations.analytics.googleAnalytics, 'accountId')
                        && isString(response.data.integrations.analytics.googleAnalytics.accountId)
                        && response.data.integrations.analytics.googleAnalytics.accountId !== '') {
                        sharedValues.integrations.analytics.googleAnalytics = {
                            accountId: response.data.integrations.analytics.googleAnalytics.accountId
                        };
                    }
                }
                if (Object.prototype.hasOwnProperty.call(response.data.integrations.analytics, 'listTrac')) {
                    if (Object.prototype.hasOwnProperty.call(response.data.integrations.analytics.listTrac, 'accountId')
                        && isString(response.data.integrations.analytics.listTrac.accountId)
                        && response.data.integrations.analytics.listTrac.accountId !== '') {
                        sharedValues.integrations.analytics.listTrac = {
                            accountId: response.data.integrations.analytics.listTrac.accountId
                        };
                        ListTrac.setAccountId(sharedValues.integrations.analytics.listTrac.accountId);
                    }
                }
            }
            if (Object.prototype.hasOwnProperty.call(response.data.integrations, 'maps')) {
                if (Object.prototype.hasOwnProperty.call(response.data.integrations.maps, 'googleMaps')) {
                    if (Object.prototype.hasOwnProperty.call(response.data.integrations.maps.googleMaps, 'publicKey')
                        && isString(response.data.integrations.maps.googleMaps.publicKey)
                        && response.data.integrations.maps.googleMaps.publicKey !== '') {
                        sharedValues.integrations.maps.googleMaps = {
                            publicKey: response.data.integrations.maps.googleMaps.publicKey
                        };
                    }
                }
            }
        }
        if (!sessionInitialized) {
            emitManual('sessionInit', 'Idx', null);
        }
        emitManual('sessionRefresh', 'Idx', null);
        sessionInitialized = true;
        if (keepAlive) {
            tokenEnableRefreshTimer();
        }
    }
    function tokenHandleBadResponse(response) {
        let errorMessage = 'Token supplied is invalid or blank';
        if (typeof response === 'object' &&
            Object.prototype.hasOwnProperty.call(response, 'data') &&
            Object.prototype.hasOwnProperty.call(response.data, 'errors') &&
            Object.prototype.hasOwnProperty.call(response.data.errors, 'length')) {
            errorMessage = response.data.errors;
        }
        else {
        }
        $mdToast.show($mdToast.simple()
            .textContent('Unable to authorize Idx feed!')
            .toastClass('errorMessage')
            .position('top right')
            .hideDelay(5000));
        return errorMessage;
    }
    function tokenEnableRefreshTimer() {
        clearTimeout(refreshLoginTimer);
        refreshLoginTimer = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
            yield tokenRefresh();
        }), (session.lastTtl - 15) * 1000);
    }
    function updateFetchTime(apiFetch, modelName, serviceId) {
        const fetchTime = apiFetch.header.get('x-fetch-time');
        if (fetchTime) {
            const oldTime = session.services[serviceId].fetchTime[modelName];
            session.services[serviceId].fetchTime[modelName] = new Date(fetchTime);
            if (!(isDate(oldTime) && isDate(session.services[serviceId].fetchTime[modelName])) ||
                oldTime.getTime() !== session.services[serviceId].fetchTime[modelName].getTime()) {
                emitManual('fetchTimeUpdate', 'Idx', null, serviceId, modelName, session.services[serviceId].fetchTime[modelName]);
            }
        }
    }
    function createModel(request) {
        if (request.api && !isString(request.api)) {
            request.api.apiVersion = apiVersion;
        }
        const model = new Model(request);
        if (Object.prototype.hasOwnProperty.call(request, 'api') &&
            request.api) {
            model.meta.set('api', isJSON(request.api)
                ? JSON.parse(request.api)
                : request.api);
        }
        if (Object.prototype.hasOwnProperty.call(request, 'serviceId')) {
            model.serviceId = request.serviceId;
        }
        return model;
    }
    function createCollection(request) {
        request.direct = true;
        if (request.api) {
            request.api.apiVersion = apiVersion;
        }
        const collection = new Collection(request);
        if (request.api) {
            collection.meta.set('api', isJSON(request.api)
                ? JSON.parse(request.api)
                : request.api);
        }
        return collection;
    }
    function fetchMergeCollections(originalCollection, collections, modelName, append = false) {
        return __awaiter(this, void 0, void 0, function* () {
            originalCollection.pending = true;
            originalCollection.completed = false;
            let maxCount = 0;
            let totalCount = 0;
            const fetchPromises = [];
            collections.forEach(collection => {
                const options = {};
                if (session.services[collection.serviceId].token !== null) {
                    options.headers = {
                        Authorization: session.services[collection.serviceId].token
                    };
                }
                fetchPromises.push($q((resolve) => __awaiter(this, void 0, void 0, function* () {
                    yield collection.fetch('POST', null, options);
                    yield modelInjectProperty(collection.models, {
                        _ServiceId: collection.serviceId
                    });
                    updateFetchTime(collection, modelName, collection.serviceId);
                    const maxRecords = collection.header.get('x-max-count');
                    const countRecords = collection.header.get('x-total-count');
                    if (maxRecords) {
                        maxCount += parseInt(maxRecords, 10);
                    }
                    if (countRecords) {
                        totalCount += parseInt(countRecords, 10);
                        if (!maxRecords) {
                            maxCount += parseInt(countRecords, 10);
                        }
                    }
                    resolve(collection.models);
                })));
            });
            if (!append) {
                originalCollection.models.splice(0, originalCollection.models.length);
            }
            return $q.all(fetchPromises)
                .then((fetchedData) => __awaiter(this, void 0, void 0, function* () {
                yield $q.all(fetchedData.map((models) => {
                    if (isArray(models)) {
                        originalCollection.models.push(...models);
                    }
                }));
                return originalCollection;
            }))
                .then(() => {
                originalCollection.header.set('x-max-count', maxCount);
                originalCollection.header.set('x-total-count', totalCount);
                originalCollection.meta.set('fetchDate', new Date());
                originalCollection.pending = false;
                originalCollection.completed = true;
                originalCollection.filtering = false;
                originalCollection.paginate = false;
                return originalCollection;
            });
        });
    }
    function fetchReplaceModel(originalModel, newModel, modelName) {
        return __awaiter(this, void 0, void 0, function* () {
            originalModel.pending = true;
            originalModel.completed = false;
            const fetchPromises = [];
            const options = {};
            if (session.services[newModel.serviceId].token !== null) {
                options.headers = {
                    Authorization: session.services[newModel.serviceId].token
                };
            }
            fetchPromises.push($q((resolve) => __awaiter(this, void 0, void 0, function* () {
                yield newModel.fetch('POST', null, options);
                yield modelInjectProperty([newModel.data], {
                    _ServiceId: newModel.serviceId
                });
                updateFetchTime(newModel, modelName, newModel.serviceId);
                resolve(newModel.data);
            })));
            const fetchedData = yield $q.all(fetchPromises);
            yield $q.all(fetchedData.map((data) => {
                originalModel.data = data;
            }));
            originalModel.meta.set('fetchDate', new Date());
            originalModel.pending = false;
            originalModel.completed = true;
            return originalModel;
        });
    }
    function modelInjectProperty(modelDatas, properties) {
        return $q.all(modelDatas.map((modelData) => {
            extend(modelData, properties);
        }));
    }
    function createOrSyncCollectionVariable(uid, moduleName, scopedCollectionVarName) {
        let collection;
        Object.keys(instance[moduleName].list).forEach(listName => {
            if (!collection &&
                listName === uid &&
                Object.prototype.hasOwnProperty.call(instance[moduleName].list, listName) &&
                Object.prototype.hasOwnProperty.call(instance[moduleName].list[listName], scopedCollectionVarName) &&
                instance[moduleName].list[listName][scopedCollectionVarName] instanceof Collection) {
                collection = instance[moduleName].list[listName][scopedCollectionVarName];
            }
        });
        if (!collection) {
            collection = new Collection();
        }
        Object.keys(instance[moduleName].list).forEach(listName => {
            if (listName === uid &&
                (!Object.prototype.hasOwnProperty.call(instance[moduleName].list[listName], scopedCollectionVarName) ||
                    instance[moduleName].list[listName][scopedCollectionVarName] !== collection)) {
                instance[moduleName].list[listName][scopedCollectionVarName] = collection;
            }
        }, this);
        return collection;
    }
    function compileGenericWhereFilter(where, searchPossibilities) {
        const whereQuery = {};
        const andStatement = [];
        const searchFunctions = {
            valueEquals: (searchObject, value) => {
                whereQuery[searchObject.apiField] = value;
            },
            stringLike: (searchObject, value) => {
                if (!isEmpty(value)) {
                    whereQuery[searchObject.apiField] = {
                        like: value,
                        options: 'i'
                    };
                }
            },
            stringLikeArray: (searchObject, value) => {
                value = typeof value === 'string' ? [value] : value;
                if (value.length > 1) {
                    const stringLikeArrayOrStatement = [];
                    value.forEach((requestedValue) => {
                        if (!isEmpty(requestedValue)) {
                            stringLikeArrayOrStatement.push({
                                [searchObject.apiField]: {
                                    like: requestedValue,
                                    options: 'i'
                                }
                            });
                        }
                    });
                    if (!isEmpty(stringLikeArrayOrStatement)) {
                        andStatement.push({ or: stringLikeArrayOrStatement });
                    }
                }
                else if (value.length === 1) {
                    if (!isEmpty(value[0])) {
                        whereQuery[searchObject.apiField] = {
                            like: value[0],
                            options: 'i'
                        };
                    }
                }
            },
            stringIncludesArray: (searchObject, value) => {
                value = typeof value === 'string' ? [value] : value;
                if (value.length > 1) {
                    whereQuery[searchObject.apiField] = {
                        inq: value
                    };
                }
                else if (value.length === 1) {
                    whereQuery[searchObject.apiField] = value[0];
                }
            },
            stringIncludesArrayAlternative: (searchObject, value) => {
                value = typeof value === 'string' ? [value] : value;
                if (value.length > 1) {
                    whereQuery[searchObject.apiField] = {
                        in: value
                    };
                }
                else if (value.length === 1) {
                    whereQuery[searchObject.apiField] = value[0];
                }
            },
            numberEqualGreater: (searchObject, value) => {
                if (value && value !== 0) {
                    if (Object.prototype.hasOwnProperty.call(whereQuery, searchObject.apiField) &&
                        Object.prototype.hasOwnProperty.call(whereQuery[searchObject.apiField], 'lte')) {
                        whereQuery[searchObject.apiField] = {
                            between: [
                                parseInt(value, 10),
                                parseInt(get(whereQuery[searchObject.apiField], 'lte'), 10)
                            ]
                        };
                    }
                    else {
                        whereQuery[searchObject.apiField] = { gte: parseInt(value, 10) };
                    }
                }
            },
            numberEqualLess: (searchObject, value) => {
                if (value && value !== 0) {
                    if (Object.prototype.hasOwnProperty.call(whereQuery, searchObject.apiField) &&
                        Object.prototype.hasOwnProperty.call(whereQuery[searchObject.apiField], 'gte')) {
                        whereQuery[searchObject.apiField] = {
                            between: [
                                parseInt(get(whereQuery[searchObject.apiField], 'gte'), 10),
                                parseInt(value, 10)
                            ]
                        };
                    }
                    else {
                        whereQuery[searchObject.apiField] = { lte: parseInt(value, 10) };
                    }
                }
            },
            andOr: (searchObject, value) => {
                if (Object.prototype.hasOwnProperty.call(searchObject, 'andOr')) {
                    const andOrOrStatement = [];
                    searchObject.andOr.forEach((orObject) => {
                        if (orObject.type === 'valueEquals') {
                            andOrOrStatement.push({
                                [orObject.apiField]: value
                            });
                        }
                        else if (orObject.type === 'stringLike') {
                            if (!isEmpty(value)) {
                                andOrOrStatement.push({
                                    [orObject.apiField]: {
                                        like: value,
                                        options: 'i'
                                    }
                                });
                            }
                        }
                        else if (orObject.type === 'stringLikeArray') {
                            value = typeof value === 'string' ? [value] : value;
                            if (value.length > 1) {
                                value.forEach((requestedValue) => {
                                    if (!isEmpty(requestedValue)) {
                                        andOrOrStatement.push({
                                            [orObject.apiField]: {
                                                like: requestedValue,
                                                options: 'i'
                                            }
                                        });
                                    }
                                });
                            }
                            else if (value.length === 1) {
                                if (!isEmpty(value[0])) {
                                    andOrOrStatement.push({
                                        [orObject.apiField]: {
                                            like: value[0],
                                            options: 'i'
                                        }
                                    });
                                }
                            }
                        }
                        else if (orObject.type === 'stringIncludesArray') {
                            value = typeof value === 'string' ? [value] : value;
                            if (value.length > 1) {
                                andOrOrStatement.push({
                                    [orObject.apiField]: {
                                        inq: value
                                    }
                                });
                            }
                            else if (value.length === 1) {
                                andOrOrStatement.push({
                                    [orObject.apiField]: value[0]
                                });
                            }
                        }
                    });
                    if (!isEmpty(andOrOrStatement)) {
                        if (andOrOrStatement.length > 1) {
                            andStatement.push({ or: andOrOrStatement });
                        }
                        else if (andOrOrStatement.length === 1) {
                            andStatement.push(andOrOrStatement[0]);
                        }
                    }
                }
            }
        };
        for (const [widgetField, searchObject] of Object.entries(searchPossibilities)) {
            if (!Object.prototype.hasOwnProperty.call(searchObject, 'apiField')) {
                searchObject.apiField = widgetField;
            }
            if (Object.prototype.hasOwnProperty.call(searchFunctions, searchObject.type) &&
                Object.prototype.hasOwnProperty.call(where, widgetField) &&
                where[widgetField] !== '') {
                searchFunctions[searchObject.type](searchObject, where[widgetField]);
            }
        }
        if (!isEmpty(andStatement)) {
            whereQuery.and = andStatement;
        }
        return whereQuery;
    }
    function compilePropertyWhereFilter(where) {
        return compileGenericWhereFilter(where, {
            ListingKey: {
                type: 'valueEquals'
            },
            ListingId: {
                type: 'stringIncludesArray'
            },
            ListingType: {
                type: 'stringIncludesArray'
            },
            Status: {
                type: 'stringIncludesArray'
            },
            ListPriceMin: {
                type: 'numberEqualGreater',
                apiField: '_BestPrice'
            },
            ListPriceMax: {
                type: 'numberEqualLess',
                apiField: '_BestPrice'
            },
            Bathrooms: {
                type: 'numberEqualGreater'
            },
            Bedrooms: {
                type: 'numberEqualGreater',
                apiField: 'BedroomsTotal'
            },
            AgentLicense: {
                type: 'stringIncludesArray'
            },
            OfficeNumber: {
                type: 'stringIncludesArray'
            },
            OfficeName: {
                type: 'stringIncludesArray'
            },
            OpenHouseOnly: {
                type: 'valueEquals'
            },
            UnparsedAddress: {
                type: 'stringLikeArray'
            },
            StreetAddress: {
                apiField: '_StreetAddress',
                type: 'stringLikeArray'
            },
            eStreetAddress: {
                apiField: '_StreetAddress',
                type: 'stringIncludesArray'
            },
            City: {
                type: 'stringLikeArray'
            },
            eCity: {
                apiField: 'City',
                type: 'stringIncludesArray'
            },
            PostalCode: {
                type: 'stringIncludesArray'
            },
            CountyOrParish: {
                type: 'stringLikeArray'
            },
            eCountyOrParish: {
                apiField: 'CountyOrParish',
                type: 'stringIncludesArray'
            },
            SubdivisionName: {
                type: 'stringLikeArray'
            },
            eSubdivisionName: {
                apiField: 'SubdivisionName',
                type: 'stringIncludesArray'
            },
            MLSAreaMajor: {
                type: 'stringLikeArray'
            },
            eMLSAreaMajor: {
                apiField: 'MLSAreaMajor',
                type: 'stringIncludesArray'
            },
            MLSAreaMinor: {
                type: 'stringLikeArray'
            },
            eMLSAreaMinor: {
                apiField: 'MLSAreaMinor',
                type: 'stringIncludesArray'
            },
            CityRegion: {
                type: 'stringLikeArray'
            },
            eCityRegion: {
                apiField: 'CityRegion',
                type: 'stringIncludesArray'
            },
            Location: {
                type: 'andOr',
                andOr: [
                    { apiField: 'City', type: 'stringLikeArray' },
                    { apiField: 'CityRegion', type: 'stringLikeArray' },
                    { apiField: 'CountyOrParish', type: 'stringLikeArray' },
                    { apiField: 'SubdivisionName', type: 'stringLikeArray' },
                    { apiField: 'MLSAreaMajor', type: 'stringLikeArray' },
                    { apiField: 'MLSAreaMinor', type: 'stringLikeArray' },
                    { apiField: 'PostalCode', type: 'stringLikeArray' },
                    { apiField: 'UnparsedAddress', type: 'stringLikeArray' },
                    { apiField: 'ListingId', type: 'stringIncludesArray' },
                ]
            },
            eLocation: {
                type: 'andOr',
                andOr: [
                    { apiField: 'City', type: 'stringIncludesArray' },
                    { apiField: 'CityRegion', type: 'stringIncludesArray' },
                    { apiField: 'CountyOrParish', type: 'stringIncludesArray' },
                    { apiField: 'SubdivisionName', type: 'stringIncludesArray' },
                    { apiField: 'MLSAreaMajor', type: 'stringIncludesArray' },
                    { apiField: 'MLSAreaMinor', type: 'stringIncludesArray' },
                    { apiField: 'PostalCode', type: 'stringIncludesArray' },
                    { apiField: 'ListingId', type: 'stringIncludesArray' },
                ]
            },
            Neighborhood: {
                type: 'andOr',
                andOr: [
                    { apiField: 'CityRegion', type: 'stringLikeArray' },
                    { apiField: 'SubdivisionName', type: 'stringLikeArray' },
                    { apiField: 'MLSAreaMajor', type: 'stringLikeArray' },
                    { apiField: 'MLSAreaMinor', type: 'stringLikeArray' }
                ]
            },
            eNeighborhood: {
                type: 'andOr',
                andOr: [
                    { apiField: 'CityRegion', type: 'stringIncludesArray' },
                    { apiField: 'SubdivisionName', type: 'stringIncludesArray' },
                    { apiField: 'MLSAreaMajor', type: 'stringIncludesArray' },
                    { apiField: 'MLSAreaMinor', type: 'stringIncludesArray' }
                ]
            }
        });
    }
    function compileMemberWhereFilter(where) {
        return compileGenericWhereFilter(where, {
            MemberKey: {
                type: 'valueEquals'
            },
            MemberStateLicense: {
                type: 'valueEquals'
            },
            MemberNationalAssociationId: {
                type: 'valueEquals'
            },
            MemberStatus: {
                type: 'valueEquals'
            },
            MemberFullName: {
                type: 'stringLike'
            }
        });
    }
    function compileOfficeWhereFilter(where) {
        return compileGenericWhereFilter(where, {
            OfficeKey: {
                type: 'valueEquals'
            },
            OfficeNationalAssociationId: {
                type: 'valueEquals'
            },
            OfficeStatus: {
                type: 'valueEquals'
            },
            OfficeNumber: {
                type: 'stringIncludesArray'
            },
            OfficeName: {
                type: 'stringLikeArray'
            }
        });
    }
    function compileOrderFilter(orderUnparsed) {
        if (typeof orderUnparsed === 'string') {
            orderUnparsed = orderUnparsed.split(',');
        }
        const orderQuery = [];
        orderUnparsed.forEach(orderName => {
            let direction = 'ASC';
            if (orderName.charAt(0) === '-') {
                orderName = orderName.substring(1, orderName.length);
                direction = 'DESC';
            }
            orderQuery.push(orderName + ' ' + direction);
        });
        return orderQuery;
    }
    function compileGenericFilter(options, filterFunction) {
        if (!options.perPage) {
            options.perPage = 20;
        }
        let activeServices = 0;
        if (typeof options.service === 'number' ||
            typeof options.service === 'string') {
            options.service = [options.service];
        }
        options.service.forEach(serviceId => {
            if (Object.prototype.hasOwnProperty.call(session.services, serviceId)) {
                activeServices++;
            }
        });
        activeServices = activeServices >= 1 ? activeServices : 1;
        let skip = 0;
        if (options.page) {
            skip = (options.page - 1) * options.perPage / activeServices;
        }
        const filterQuery = {
            where: filterFunction(options.where),
            limit: options.perPage,
            skip
        };
        if (options.fields) {
            filterQuery.fields = options.fields;
        }
        if (options.order && options.order.length > 0) {
            filterQuery.order = compileOrderFilter(options.order);
        }
        const includes = [];
        const includeOptions = {
            images: {
                relation: 'Images',
                scope: {
                    order: 'Order',
                    fields: [
                        'MediaURL'
                    ]
                }
            },
            openhouses: {
                relation: 'OpenHouses',
                scope: {
                    order: 'OpenHouseStartTime',
                    fields: [
                        'OpenHouseStartTime',
                        'OpenHouseEndTime'
                    ]
                }
            },
            office: {
                relation: 'Office',
                scope: {
                    fields: [
                        'OfficeName',
                        'OfficeKey'
                    ]
                }
            },
            managingBroker: {
                relation: 'Member',
                scope: {
                    fields: [
                        'MemberFullName',
                        'MemberStateLicense',
                        'MemberKey'
                    ]
                }
            },
            members: {
                relation: 'Member',
                scope: {
                    fields: [
                        'MemberFullName',
                        'MemberStateLicense',
                        'MemberKey'
                    ]
                }
            }
        };
        Object.entries(includeOptions).forEach(([optionName, includeItem]) => {
            if (Object.prototype.hasOwnProperty.call(options, optionName)) {
                const option = options[optionName];
                if (typeof option === 'object') {
                    if (Object.prototype.hasOwnProperty.call(option, 'fields')) {
                        if (option.fields === '*') {
                            delete includeItem.scope.fields;
                        }
                        else {
                            includeItem.scope.fields = option.fields;
                        }
                    }
                    else if (Object.prototype.hasOwnProperty.call(option, 'limit') &&
                        isNumber(option.limit)) {
                        includeItem.scope.limit = option.limit;
                    }
                }
                if (option !== false) {
                    includes.push(includeItem);
                }
            }
        });
        if (includes.length === 1) {
            filterQuery.include = includes[0];
        }
        else if (includes.length > 1) {
            filterQuery.include = includes;
        }
        if (filterQuery.fields.length <= 0) {
            delete filterQuery.fields;
        }
        return filterQuery;
    }
    function compilePropertyFilter(options) {
        return compileGenericFilter(options, compilePropertyWhereFilter);
    }
    function compileMemberFilter(options) {
        return compileGenericFilter(options, compileMemberWhereFilter);
    }
    function compileOfficeFilter(options) {
        return compileGenericFilter(options, compileOfficeWhereFilter);
    }
    function getMLSVariables(serviceIds) {
        const serviceList = [];
        if (serviceIds && isArray(serviceIds)) {
            serviceIds.forEach(serviceId => {
                if (Object.prototype.hasOwnProperty.call(session.services, serviceId)) {
                    serviceList.push({
                        id: session.services[serviceId].id,
                        name: session.services[serviceId].name,
                        disclaimer: session.services[serviceId].disclaimer,
                        fetchTime: session.services[serviceId].fetchTime,
                        analyticsEnabled: session.services[serviceId].analyticsEnabled,
                        logo: session.services[serviceId].logo,
                        mandatoryLogo: session.services[serviceId].mandatoryLogo
                    });
                }
            });
        }
        else {
            Object.values(session.services).forEach(service => {
                if (!isEmpty(service)) {
                    serviceList.push({
                        id: service.id,
                        name: service.name,
                        disclaimer: service.disclaimer,
                        fetchTime: service.fetchTime,
                        analyticsEnabled: service.analyticsEnabled,
                        logo: service.logo,
                        mandatoryLogo: service.mandatoryLogo
                    });
                }
            });
        }
        return serviceList;
    }
    function getContactVariables() {
        return session.contacts;
    }
    function getOptionsFromUrl() {
        let hash = getHashBangParam('#!');
        hash = getListingOptionsFromUrlString(hash);
        getSearchOptionsFromUrlString(hash);
        return urlOptions;
    }
    function getListingOptionsFromUrlString(path) {
        const regex = /\/Listing\/(\d{1,3})\/([^/\s]+)(\/?[\w\-_]*\/?)?/;
        const matches = regex.exec(path);
        path = path.replace(regex, '');
        if (matches !== null &&
            matches[1] &&
            matches[2]) {
            urlOptions.Listing.service = matches[1];
            urlOptions.Listing.ListingKey = matches[2];
        }
        return path;
    }
    function getSearchOptionsFromUrlString(path) {
        let regex = /\/Search\/(.*)?\/?/;
        let matches = regex.exec(path);
        path = path.replace(regex, '');
        if (matches !== null &&
            matches[1]) {
            const rawSearchOptions = matches[1];
            regex = /([^/]+)\/([^/]*)/g;
            const whileLoopAssignmentBypass = (regexp, value) => {
                matches = regexp.exec(value);
                return matches;
            };
            while (whileLoopAssignmentBypass(regex, rawSearchOptions) != null) {
                if (matches[1]) {
                    if (matches[2] && matches[2].includes(',')) {
                        urlOptions.Search[matches[1]] = matches[2].split(',');
                    }
                    else {
                        urlOptions.Search[matches[1]] = matches[2];
                    }
                }
            }
        }
        if (Object.prototype.hasOwnProperty.call(urlOptions.Search, 'Page')) {
            if (isString(urlOptions.Search.Page)) {
                urlOptions.Search.Page = parseInt(urlOptions.Search.Page, 10);
            }
        }
        return path;
    }
    function setUrlOptions(listingOrSearch, options) {
        urlOptions[listingOrSearch] = options || {};
    }
    function getUrlOptions(listingOrSearch) {
        return urlOptions[listingOrSearch];
    }
    function getUrlOptionsPath(defaultOptions) {
        defaultOptions !== null && defaultOptions !== void 0 ? defaultOptions : (defaultOptions = {});
        let path = '';
        const searchOptionNames = Object.keys(urlOptions.Search);
        if (searchOptionNames.length > 0) {
            let searchPath = '';
            searchOptionNames.forEach(searchOptionName => {
                if (Object.prototype.hasOwnProperty.call(urlOptions.Search, searchOptionName) &&
                    urlOptions.Search[searchOptionName] !== null) {
                    let defaultValue = defaultOptions[searchOptionName];
                    const compareValue = urlOptions.Search[searchOptionName];
                    if (!isArray(defaultValue) &&
                        isArray(compareValue)) {
                        defaultValue = [defaultValue];
                    }
                    if (!isEqual(defaultValue, compareValue)) {
                        searchPath += searchOptionName + '/' + compareValue + '/';
                    }
                }
            });
            if (searchPath !== '') {
                path += 'Search/' + searchPath;
            }
        }
        if (Object.prototype.hasOwnProperty.call(urlOptions.Listing, 'service') &&
            Object.prototype.hasOwnProperty.call(urlOptions.Listing, 'ListingKey') &&
            !isNaN(urlOptions.Listing.service) &&
            urlOptions.Listing.ListingKey) {
            path += 'Listing' + '/' + urlOptions.Listing.service + '/' + urlOptions.Listing.ListingKey + '/';
            if (Object.prototype.hasOwnProperty.call(urlOptions.Listing, 'address') &&
                urlOptions.Listing.address &&
                typeof urlOptions.Listing.address === 'string') {
                path += urlOptions.Listing.address.replace(/ /g, '-') + '/';
            }
        }
        if (path.length) {
            path = '/' + path;
        }
        return path;
    }
    function devLog(...items) {
        if (cookie('env')) {
            console.log(...items);
        }
    }
    function getLastQueryTime() {
        return lastQueries.time;
    }
    function getLastSessionTime() {
        return session.lastCreated;
    }
    function refreshUrlOptions(defaultOptions) {
        setLocationPath(getUrlOptionsPath(defaultOptions));
    }
    function setLocationPath(path) {
        $rootScope.$applyAsync(() => {
            setHashBangParam(path, '#!');
        });
    }
    function orderBy(collection, propertyNames, reverse = false) {
        if (propertyNames) {
            const orderPropertyNames = isArray(propertyNames) ? clone(propertyNames) : [clone(propertyNames)];
            orderPropertyNames.forEach((item, index) => {
                if (item === 'BestPrice') {
                    orderPropertyNames[index] = '_BestPrice';
                }
                else if (item === '-BestPrice') {
                    orderPropertyNames[index] = '-_BestPrice';
                }
                if (item === 'Status') {
                    orderPropertyNames[index] = '_Status';
                }
                else if (item === '-Status') {
                    orderPropertyNames[index] = '-_Status';
                }
            });
            collection.models = orderByFilter(collection.models, orderPropertyNames, reverse);
        }
    }
    function getSingularApiModelName(name) {
        let apiModelSingular = 'Property';
        switch (name) {
            case 'Properties':
                apiModelSingular = 'Property';
                break;
            case 'Members':
                apiModelSingular = 'Member';
                break;
            case 'Offices':
                apiModelSingular = 'Office';
                break;
            case 'OpenHouses':
                apiModelSingular = 'OpenHouse';
                break;
        }
        return apiModelSingular;
    }
    function genericSearchCollection(uid, collectionVarName, options = {}, refresh = false, moduleName, apiModel, compileFilterFunction) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = options.service) !== null && _a !== void 0 ? _a : (options.service = []);
            (_b = options.where) !== null && _b !== void 0 ? _b : (options.where = {});
            (_c = options.order) !== null && _c !== void 0 ? _c : (options.order = []);
            (_d = options.page) !== null && _d !== void 0 ? _d : (options.page = 1);
            (_e = options.perPage) !== null && _e !== void 0 ? _e : (options.perPage = 10);
            options.images || (options.images = false);
            (_f = options.fields) !== null && _f !== void 0 ? _f : (options.fields = [
                '_id'
            ]);
            if (typeof options.order === 'string') {
                options.order = options.order.split(',');
            }
            if (typeof options.service === 'number') {
                options.service = [options.service];
            }
            if (options.service.length === 0) {
                options.service = [0];
            }
            const apiModelSingular = getSingularApiModelName(apiModel);
            const collection = createOrSyncCollectionVariable(uid, moduleName, collectionVarName);
            const filterQuery = compileFilterFunction(options);
            const collections = [];
            if (!isEqual(lastQueries.whereFilter, filterQuery.where) ||
                lastQueries.order !== options.order ||
                lastQueries.perPage !== options.perPage ||
                refresh) {
                collection.models.splice(0, collection.models.length);
                refresh = true;
                lastQueries.pages = [];
                filterQuery.count = true;
            }
            else {
                refresh = false;
            }
            if (collection.models.length < (options.page * options.perPage)) {
                collection.pending = true;
                Object.keys(instance[moduleName].list).forEach(listName => {
                    instance[moduleName].list[listName].$applyAsync();
                });
                if (options.page > 1 &&
                    !lastQueries.pages.includes(options.page - 1, options.page - 2)) {
                    filterQuery.limit = options.perPage * options.page;
                    filterQuery.skip = 0;
                    for (let addPage = 1; addPage < options.page; addPage++) {
                        lastQueries.pages.push(addPage);
                    }
                }
                if (options.service.length !== 0) {
                    setIdxServices(options.service);
                }
                else {
                    options.service = getIdxServices();
                }
                yield tokenKeepAuth();
                if (options.service.length === 0) {
                    options.service = Object.keys(session.services);
                }
                options.service.forEach((serviceId) => {
                    var _a;
                    if (Object.prototype.hasOwnProperty.call(session.services, serviceId)) {
                        const filterQueryCustom = clone(filterQuery);
                        if (!refresh) {
                            filterQueryCustom.skip = ((_a = get(collection.meta, `data.recordCounts[${serviceId}]`)) !== null && _a !== void 0 ? _a : 0);
                        }
                        const request = {
                            serviceId,
                            urlRoot: session.services[serviceId].host,
                            target: apiModel + '/search',
                            api: {
                                filter: filterQueryCustom,
                                meta: {
                                    action: 'search',
                                    format: 'reso'
                                },
                                route: {
                                    controller: apiModelSingular
                                }
                            }
                        };
                        collections.push(createCollection(request));
                    }
                });
                yield fetchMergeCollections(collection, collections, apiModelSingular, !refresh);
                if (refresh) {
                    const maxRecords = collection.header.get('x-max-count') || 0;
                    const totalRecords = collection.header.get('x-total-count') || 0;
                    collection.meta.set('maxRecords', maxRecords);
                    collection.meta.set('totalRecords', totalRecords);
                    collection.meta.set('totalPages', Math.ceil((maxRecords || totalRecords) / options.perPage));
                }
                orderBy(collection, options.order);
                if (collection.models.length > (options.page * options.perPage)) {
                    collection.models.splice(options.page * options.perPage, collection.models.length);
                }
                const recordCounts = {};
                yield $q.all(collection.models.map((model) => {
                    var _a;
                    var _b;
                    (_a = recordCounts[_b = model._ServiceId]) !== null && _a !== void 0 ? _a : (recordCounts[_b] = 0);
                    recordCounts[model._ServiceId]++;
                }));
                collection.meta.set('recordCounts', recordCounts);
                Object.keys(instance[moduleName].list).forEach(listName => {
                    instance[moduleName].list[listName].$applyAsync();
                });
            }
            lastQueries.whereFilter = clone(filterQuery.where);
            lastQueries.order = options.order;
            lastQueries.perPage = options.perPage;
            lastQueries.pages.push(options.page);
            lastQueries.time = new Date();
            return collection;
        });
    }
    function genericSearchModel($scope, modelVarName, options = {}, apiModel, compileFilterFunction) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            yield tokenKeepAuth();
            (_a = options.service) !== null && _a !== void 0 ? _a : (options.service = 0);
            (_b = options.where) !== null && _b !== void 0 ? _b : (options.where = {});
            options.images || (options.images = false);
            (_c = options.fields) !== null && _c !== void 0 ? _c : (options.fields = []);
            options.perPage = 1;
            if (isArray(options.service)) {
                options.service = options.service[0];
            }
            const apiModelSingular = getSingularApiModelName(apiModel);
            let model;
            if (Object.prototype.hasOwnProperty.call($scope, modelVarName)) {
                model = $scope[modelVarName];
            }
            if (!model) {
                model = new Model();
            }
            if (!Object.prototype.hasOwnProperty.call($scope, modelVarName) ||
                $scope[modelVarName] !== model) {
                $scope[modelVarName] = model;
            }
            if (Object.prototype.hasOwnProperty.call(session.services, options.service)) {
                const request = {
                    serviceId: options.service,
                    urlRoot: session.services[options.service].host,
                    target: apiModel + '/search',
                    api: {
                        filter: compileFilterFunction(options),
                        meta: {
                            action: 'search',
                            format: 'reso'
                        },
                        route: {
                            controller: apiModelSingular
                        }
                    }
                };
                const tempModel = createModel(request);
                fetchReplaceModel(model, tempModel, apiModelSingular)
                    .then(() => {
                    $scope.$applyAsync();
                });
            }
            lastQueries.time = new Date();
            return $scope[modelVarName];
        });
    }
    function fetchProperties(uid, collectionVarName, options = {}, refresh = false) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = options.service) !== null && _a !== void 0 ? _a : (options.service = []);
            if (!options.where &&
                !isEmpty(urlOptions.Search)) {
                const whereReAssign = urlOptions.Search;
                delete urlOptions.Search.Page;
                delete urlOptions.Search.Order;
                options.where = whereReAssign;
            }
            (_b = options.where) !== null && _b !== void 0 ? _b : (options.where = {});
            (_c = options.order) !== null && _c !== void 0 ? _c : (options.order = urlOptions.Search.Order || []);
            (_d = options.page) !== null && _d !== void 0 ? _d : (options.page = urlOptions.Search.Page || 1);
            (_e = options.perPage) !== null && _e !== void 0 ? _e : (options.perPage = 10);
            options.images || (options.images = false);
            (_f = options.fields) !== null && _f !== void 0 ? _f : (options.fields = [
                '_id',
                '_Class',
                'MlsStatus',
                'PropertyType',
                'PropertySubType',
                'UnparsedAddress',
                'StreetNumber',
                'StreetNumberNumeric',
                'StreetName',
                'StreetSuffix',
                'UnitNumber',
                'City',
                'CityRegion',
                'MLSAreaMajor',
                'MLSAreaMinor',
                'CountyOrParish',
                'StateOrProvince',
                'Latitude',
                'Longitude',
                'ListPrice',
                'ClosePrice',
                'ListingId',
                'ListingKey',
                'BathroomsTotalInteger',
                'BathroomsFull',
                'BathroomsHalf',
                'BathroomsOneQuarter',
                'BathroomsThreeQuarter',
                'BathroomsPartial',
                'BedroomsTotal'
            ]);
            if (Object.prototype.hasOwnProperty.call(options.where, 'OpenHouseOnly') &&
                isString(options.where.OpenHouseOnly)) {
                options.where.OpenHouseOnly = (options.where.OpenHouseOnly === 'true');
            }
            if (Object.prototype.hasOwnProperty.call(options.where, 'OpenHouseOnly') &&
                options.where.OpenHouseOnly) {
                options.openhouses = true;
            }
            if (isEmpty(options.where.Neighborhood) &&
                isEmpty(options.where.eNeighborhood) &&
                isEmpty(options.where.Location) &&
                isEmpty(options.where.eLocation) &&
                isEmpty(options.where.AgentLicense) &&
                isEmpty(options.where.OfficeNumber) &&
                isEmpty(options.where.City) &&
                isEmpty(options.where.eCity) &&
                isEmpty(options.where.CityRegion) &&
                isEmpty(options.where.eCityRegion) &&
                isEmpty(options.where.CountyOrParish) &&
                isEmpty(options.where.eCountyOrParish) &&
                isEmpty(options.where.MLSAreaMajor) &&
                isEmpty(options.where.eMLSAreaMajor) &&
                isEmpty(options.where.MLSAreaMinor) &&
                isEmpty(options.where.eMLSAreaMinor) &&
                isEmpty(options.where.PostalCode) &&
                isEmpty(options.where.UnparsedAddress)) {
                options.openhouses = false;
                delete options.where.OpenHouseOnly;
            }
            return genericSearchCollection(uid, collectionVarName, options, refresh, 'property', 'Properties', compilePropertyFilter);
        });
    }
    function fetchProperty($scope, modelVarName, options = {}) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = options.service) !== null && _a !== void 0 ? _a : (options.service = null);
            (_b = options.where) !== null && _b !== void 0 ? _b : (options.where = {});
            options.images || (options.images = false);
            options.openhouses || (options.openhouses = false);
            (_c = options.fields) !== null && _c !== void 0 ? _c : (options.fields = []);
            return genericSearchModel($scope, modelVarName, options, 'Properties', compilePropertyFilter);
        });
    }
    function fetchMembers(uid, collectionVarName, options = {}, refresh = false) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = options.service) !== null && _a !== void 0 ? _a : (options.service = []);
            (_b = options.where) !== null && _b !== void 0 ? _b : (options.where = {});
            (_c = options.order) !== null && _c !== void 0 ? _c : (options.order = []);
            (_d = options.page) !== null && _d !== void 0 ? _d : (options.page = 1);
            (_e = options.perPage) !== null && _e !== void 0 ? _e : (options.perPage = 10);
            options.images || (options.images = false);
            options.office || (options.office = false);
            (_f = options.fields) !== null && _f !== void 0 ? _f : (options.fields = [
                '_id',
                'MemberKey',
                'MemberStateLicense',
                'MemberNationalAssociationId',
                'MemberFirstName',
                'MemberLastName',
                'MemberFullName',
                'MemberStatus',
                'MemberMlsAccessYN',
                'MemberType',
                'MemberAOR',
                'OfficeKey',
                'OfficeMlsId',
                'OfficeName',
                'OriginatingSystemName',
                'SourceSystemName'
            ]);
            return genericSearchCollection(uid, collectionVarName, options, refresh, 'member', 'Members', compileMemberFilter);
        });
    }
    function fetchOffices(uid, collectionVarName, options = {}, refresh = false) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = options.service) !== null && _a !== void 0 ? _a : (options.service = []);
            (_b = options.where) !== null && _b !== void 0 ? _b : (options.where = {});
            (_c = options.order) !== null && _c !== void 0 ? _c : (options.order = []);
            (_d = options.page) !== null && _d !== void 0 ? _d : (options.page = 1);
            (_e = options.perPage) !== null && _e !== void 0 ? _e : (options.perPage = 10);
            options.images || (options.images = false);
            options.managingBroker || (options.managingBroker = false);
            options.members || (options.members = false);
            (_f = options.fields) !== null && _f !== void 0 ? _f : (options.fields = [
                '_id',
                'OfficeKey',
                'OfficeMlsId',
                'OfficeName',
                'OfficeNationalAssociationId',
                'OfficeStatus',
                'OfficePhone',
                'OfficeAddress1',
                'OfficeCity',
                'OfficePostalCode',
                'OfficeBrokerKey'
            ]);
            refresh || (refresh = false);
            return genericSearchCollection(uid, collectionVarName, options, refresh, 'office', 'Offices', compileOfficeFilter);
        });
    }
    function getFriendlyStatus(property, preferredStatus = 'Closed') {
        let statusName = '';
        if (Object.prototype.hasOwnProperty.call(property, 'MlsStatus') &&
            property.MlsStatus !== '') {
            statusName = property.MlsStatus;
        }
        else if (Object.prototype.hasOwnProperty.call(property, 'StandardStatus') &&
            property.StandardStatus !== '') {
            statusName = property.StandardStatus;
        }
        if (statusName !== '') {
            switch (statusName) {
                case 'Act Cont Release':
                case 'Act Cont Show':
                case 'Contingent - Release':
                case 'Contingent - Show':
                case 'Contingent-Release':
                case 'Contingent-Show': {
                    statusName = 'Contingent';
                    break;
                }
                default:
                    statusName = getFriendlyClosedStatus(property, statusName, preferredStatus);
            }
        }
        return statusName;
    }
    function getFriendlyPriceLabel(property) {
        let priceLabel = 'List';
        if (property.hasOwnProperty('ClosePrice')) {
            const statusName = getFriendlyStatus(property);
            switch (statusName) {
                case 'Closed': {
                    priceLabel = 'Sale';
                    break;
                }
                case 'Leased': {
                    priceLabel = 'Lease';
                    break;
                }
                case 'Rented': {
                    priceLabel = 'Rent';
                    break;
                }
                default:
                    priceLabel = 'Sale';
            }
        }
        priceLabel += ' Price';
        return priceLabel;
    }
    function getFullStatus(property, preferredStatus = 'Closed') {
        let statusName = '';
        if (Object.prototype.hasOwnProperty.call(property, 'MlsStatus') &&
            property.MlsStatus !== '') {
            statusName = property.MlsStatus;
        }
        else if (Object.prototype.hasOwnProperty.call(property, 'StandardStatus') &&
            property.StandardStatus !== '') {
            statusName = property.StandardStatus;
        }
        if (statusName !== '') {
            statusName = getFriendlyClosedStatus(property, statusName, preferredStatus);
        }
        return statusName;
    }
    function getFriendlyClosedStatus(property, statusName, preferredStatus = 'Closed') {
        if (statusName !== '') {
            if (preferredStatus === 'Closed') {
                switch (statusName) {
                    case 'Sold':
                    case 'Leased/Option':
                    case 'Leased/Rented': {
                        statusName = 'Closed';
                        break;
                    }
                }
            }
            else {
                switch (statusName) {
                    case 'Closed':
                    case 'Sold':
                        statusName = 'Sold';
                        if (Object.prototype.hasOwnProperty.call(property, '_IsRental') &&
                            property._IsRental) {
                            statusName = preferredStatus;
                        }
                        break;
                    case 'Leased/Option':
                    case 'Leased/Rented': {
                        statusName = preferredStatus;
                        break;
                    }
                }
            }
        }
        return statusName;
    }
    function getStreetAddress(property) {
        if ((Object.prototype.hasOwnProperty.call(property, 'StreetName') && property.StreetName !== '') ||
            !Object.prototype.hasOwnProperty.call(property, 'UnparsedAddress') || property.UnparsedAddress === '') {
            const addressParts = [];
            if (Object.prototype.hasOwnProperty.call(property, 'StreetNumberNumeric') &&
                isNumber(property.StreetNumberNumeric) &&
                property.StreetNumberNumeric > 0) {
                addressParts.push(property.StreetNumberNumeric.toString());
            }
            else if (Object.prototype.hasOwnProperty.call(property, 'StreetNumber') &&
                property.StreetNumber !== '') {
                addressParts.push(property.StreetNumber);
            }
            [
                'StreetDirPrefix',
                'StreetName',
                'StreetSuffix',
                'StreetSuffixModifier',
                'StreetDirSuffix',
                'UnitNumber'
            ]
                .forEach((addressPart) => {
                if (Object.prototype.hasOwnProperty.call(property, addressPart)) {
                    if (addressPart === 'StreetSuffix' &&
                        property[addressPart] === 'None') {
                        property[addressPart] = '';
                    }
                    if (addressPart === 'UnitNumber') {
                        addressParts.push('Unit');
                    }
                    if (!isEmpty(property[addressPart])) {
                        addressParts.push(property[addressPart]);
                    }
                }
            });
            return addressParts.join(' ');
        }
        else {
            return property.UnparsedAddress || '';
        }
    }
    function getFullAddress(property, encode) {
        const address = getStreetAddress(property) + ', ' + property.City + ' ' + property.StateOrProvince;
        return encode ? encodeURIComponent(address) : address;
    }
    function getGoogleMapsKey() {
        let googleMapsKey = null;
        if (sharedValues.integrations
            && Object.prototype.hasOwnProperty.call(sharedValues.integrations, 'maps')
            && Object.prototype.hasOwnProperty.call(sharedValues.integrations.maps, 'googleMaps')
            && Object.prototype.hasOwnProperty.call(sharedValues.integrations.maps.googleMaps, 'publicKey')
            && sharedValues.integrations.maps.googleMaps.publicKey !== '') {
            googleMapsKey = sharedValues.integrations.maps.googleMaps.publicKey;
        }
        return googleMapsKey;
    }
    function getWebsiteMainContact() {
        const contact = {
            name: null,
            email: null,
            phone: null,
        };
        if (isPlainObject(sharedValues.contact)) {
            contact.name = clone(sharedValues.contact.name);
            if (sharedValues.contact.emails.hasOwnProperty('Main')) {
                contact.email = clone(sharedValues.contact.emails.Main);
            }
            if (sharedValues.contact.phones.hasOwnProperty('Main')) {
                contact.phone = clone(sharedValues.contact.phones.Main);
            }
        }
        if (!isString(contact.name) || contact.name === '') {
            return null;
        }
        return contact;
    }
    function getInput(elementId) {
        return element(document.getElementById(elementId));
    }
    function getScopeValuePath(scope, scopeVarPath) {
        const scopePieces = scopeVarPath.split('.');
        return getNestedPathValue(scope, scopePieces);
    }
    function getNestedPathValue(currentNest, pathPieces) {
        const currentPiece = pathPieces.shift();
        if (pathPieces[0]) {
            return getNestedPathValue(currentNest[currentPiece], pathPieces);
        }
        else if (Object.prototype.hasOwnProperty.call(currentNest, currentPiece)) {
            return currentNest[currentPiece];
        }
        else {
            return null;
        }
    }
    function updateScopeValuePath(scope, scopeVarPath, value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (value == null ||
                value === 'null' ||
                value === '') {
                return false;
            }
            const scopePieces = scopeVarPath.split('.');
            return updateNestedPathValue(scope, scopePieces, value);
        });
    }
    function updateNestedPathValue(currentNest, pathPieces, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentPiece = pathPieces.shift();
            if (currentPiece) {
                if (pathPieces[0]) {
                    return updateNestedPathValue(currentNest[currentPiece], pathPieces, value);
                }
                else if (Object.prototype.hasOwnProperty.call(currentNest, currentPiece) &&
                    (!isArray(currentNest[currentPiece]) && isArray(value))) {
                    console.warn('updateNestedPathValue couldn\'t connect', currentPiece, ' as value given is array, but value stored is not: ', clone(currentNest), 'It may need to be initialized first (as an array)');
                }
                else {
                    if (isArray(currentNest[currentPiece]) && !isArray(value) && !isJSON(value)) {
                        value = value === '' ? [] : value.split(',');
                    }
                    if (!isArray(value) &&
                        (isObject(currentNest[currentPiece]) ||
                            isJSON(value))) {
                        currentNest[currentPiece] = JSON.parse(value);
                    }
                    else {
                        currentNest[currentPiece] = clone(value);
                    }
                    return value;
                }
            }
            else {
                console.warn('updateNestedPathValue couldn\'t find', currentPiece, 'in', clone(currentNest), 'It may need to be initialized first');
                return null;
            }
        });
    }
    function clearFieldInput(ev) {
        if (ev &&
            ev.hasOwnProperty('target') &&
            ev.target &&
            ev.target.hasOwnProperty('value')) {
            ev.target.value = null;
        }
    }
    function countArraysNotEmpty(arrayList) {
        return arrayList.filter((e) => e.length).length;
    }
    function ensureItemsAreArrays(itemParent, itemNames) {
        itemNames.forEach(itemName => {
            if (itemParent.hasOwnProperty(itemName) &&
                !isArray(itemParent[itemName])) {
                itemParent[itemName] = isEmpty(itemParent[itemName]) ? [] : [itemParent[itemName]];
            }
        });
    }
    return {
        apiVersion,
        fetchMembers,
        fetchOffices,
        fetchProperties,
        fetchProperty,
        clearFieldInput,
        countArraysNotEmpty,
        devLog,
        emit,
        emitManual,
        ensureItemsAreArrays,
        getContactVariables,
        getDefaultWhereOptions,
        getDisclaimerInstance,
        getFriendlyPriceLabel,
        getFriendlyStatus,
        getFullAddress,
        getFullStatus,
        getGoogleMapsKey,
        getIdxServices,
        getInput,
        getScopeValuePath,
        getLastQueryTime,
        getLastSessionTime,
        getListInstance,
        getListInstanceLinks,
        getMLSVariables,
        getNestedPathValue,
        getOptionsFromUrl,
        getSearchInstanceLinks,
        getStreetAddress,
        getUrlOptions,
        getUrlOptionsPath,
        getWebsiteMainContact,
        on,
        registerDetailsInstance,
        registerDisclaimerInstance,
        registerListInstance,
        registerMapInstance,
        registerSearchInstance,
        setIdxServices,
        setPageTitle,
        setTokenURL,
        setUrlOptions,
        sharedValues,
        tokenKeepAuth,
        refreshUrlOptions,
        updateNestedPathValue,
        updateScopeValuePath,
        unregisterDetailsInstance
    };
};
Stratus.Services.Idx = [
    '$provide',
    ($provide) => {
        $provide.factory('Idx', angularJsService);
    }
];

//# sourceMappingURL=idx.js.map
